// extracted by mini-css-extract-plugin
module.exports = {"scrollable_menu":"GameCustomChapter_scrollable_menu__2MdGg"};